"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-maria-del-cedro": {
    "19069461": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "abatemarco": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0edad370": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "bonia": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f55732fb": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "bordiero": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b4d0606d": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "carcere-impresa": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6dea21ce": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "castel-san-michele": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b979a83": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "cozza-di-patacca": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34454ab6": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "foreste": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e360827": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "fosse": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "997f440a": [{
      "hkey": "9910239b",
      "slug": "marina-di-santa-maria-del-cedro",
      "name": "Marina di Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "granata": [{
      "hkey": "9910239b",
      "slug": "marina-di-santa-maria-del-cedro",
      "name": "Marina di Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b247e598": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "grotte": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "feda468d": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "moscatella": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d8580ec": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "pantani": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0799940b": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "perato": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "39ba13c8": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "pioppo-valline": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9b8158af": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "san-bartolo": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2e32a5a6": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6616b32c": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "santoro": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24e98fde": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "skipSearch": false
    }],
    "vizioso": [{
      "hkey": "9d38fd5e",
      "slug": "santa-maria-del-cedro",
      "name": "Santa Maria del Cedro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;